export default "__VITE_ASSET__Cs0xqjKB__"